module.exports = __webpack_public_path__ + "assets/img/vampire-idle.808c5589.png";